// Helper to build asset URLs from public folder
import { assetUrl } from "../utils/assetUrl";

export interface MediaOwner {
  id: string;
  name: string;
  logo: string;
  bannerImage: string;
  tagline: string;
  rating: number;
  reviewCount: number;
  followers: number;
  itemsSold: number;
  joinedDate: string;
  responseTime: string;
  location: string;
  description: string;
  verified: boolean;
  brandColor: string; // Primary brand color
  specialties: string[]; // What they specialize in
}

export const mediaOwners: Record<string, MediaOwner> = {
  "politis-media": {
    id: "politis-media",
    name: "Politis Out of Home Media",
    logo: assetUrl("POLITIS OUT OF HOME MEDIA_2_1753786476141.png"),
    bannerImage: assetUrl("oOh_20240101_Street_Digital_Adelaide-CBD_SA-Volvo-1024x635-1_1753792412446.jpg"),
    tagline: "Premium Urban Digital Advertising Solutions",
    rating: 4.8,
    reviewCount: 2341,
    followers: 12400,
    itemsSold: 3890,
    joinedDate: "Mar 2019",
    responseTime: "Usually responds within 12 hours",
    location: "Sydney, Melbourne & Brisbane",
    description: "Leading provider of premium urban digital advertising solutions across Australia's major metropolitan areas. Specializing in high-traffic CBD locations and transport hubs.",
    verified: true,
    brandColor: "#4338ca", // Indigo
    specialties: ["Urban Digital", "Transport Hubs", "CBD Premium"]
  },

  "firefly-digital": {
    id: "firefly-digital",
    name: "Firefly Digital Networks",
    logo: assetUrl("firfly2_1753786476142.png"),
    bannerImage: assetUrl("digital-billboards-01_1753792412449.jpg"),
    tagline: "Illuminating Brands Through Digital Innovation",
    rating: 4.9,
    reviewCount: 1876,
    followers: 9800,
    itemsSold: 2456,
    joinedDate: "Aug 2020",
    responseTime: "Usually responds within 6 hours",
    location: "Perth, Adelaide & Darwin",
    description: "Innovative digital billboard network specializing in high-impact LED displays and interactive advertising solutions. Focus on technology-driven outdoor advertising.",
    verified: true,
    brandColor: "#000000", // Black
    specialties: ["LED Technology", "Interactive Displays", "Night Advertising"]
  },

  "tractor-outdoor": {
    id: "tractor-outdoor",
    name: "Tractor Outdoor Advertising",
    logo: assetUrl("Tractor_1753786476143.png"),
    bannerImage: assetUrl("mini_outdoor_aotw_1753792412448.jpg"),
    tagline: "Cultivating Brand Growth Across Australia",
    rating: 4.7,
    reviewCount: 1542,
    followers: 7600,
    itemsSold: 1890,
    joinedDate: "Jan 2018",
    responseTime: "Usually responds within 24 hours",
    location: "Regional Australia & Highway Networks",
    description: "Specializing in regional and highway advertising solutions. Connecting brands with audiences across Australia's regional centers and major transport corridors.",
    verified: true,
    brandColor: "#000000", // Black
    specialties: ["Regional Advertising", "Highway Billboards", "Rural Networks"]
  },

  "backlite-media": {
    id: "backlite-media",
    name: "Backlite Media Solutions",
    logo: assetUrl("bakclite 2_1753786476144.png"),
    bannerImage: assetUrl("What_You_Need_To_Know_About_Digital_Billboards_dfdfb2b5cc_1753792412449.jpg"),
    tagline: "Premium Backlit Advertising Excellence",
    rating: 4.6,
    reviewCount: 987,
    followers: 5400,
    itemsSold: 1234,
    joinedDate: "Nov 2021",
    responseTime: "Usually responds within 18 hours",
    location: "Melbourne & Sydney",
    description: "Specialists in premium backlit advertising solutions. Offering high-quality illuminated displays for maximum brand visibility and impact.",
    verified: true,
    brandColor: "#000000", // Black
    specialties: ["Backlit Displays", "Premium Illumination", "Brand Visibility"]
  },

  "blue-label-media": {
    id: "blue-label-media",
    name: "Blue Label Media",
    logo: assetUrl("blue-label-media-logo-white@2x_1_1753786476144.png"),
    bannerImage: assetUrl("piccadillyBanner_1753792412448.jpg"),
    tagline: "Creative Outdoor Advertising Solutions",
    rating: 4.8,
    reviewCount: 1654,
    followers: 8900,
    itemsSold: 2100,
    joinedDate: "Jun 2020",
    responseTime: "Usually responds within 8 hours",
    location: "Brisbane & Gold Coast",
    description: "Creative outdoor advertising specialists focusing on innovative campaign solutions and premium locations across Queensland's major metropolitan areas.",
    verified: true,
    brandColor: "#3b82f6", // Blue
    specialties: ["Creative Campaigns", "Queensland Network", "Premium Locations"]
  },

  "qms-media": {
    id: "qms-media",
    name: "QMS Media Group",
    logo: assetUrl("QMS_Logo_POS_RGB_1753786476145.webp"),
    bannerImage: assetUrl("skyBillboardBanner_1753792412450.jpg"),
    tagline: "Australia's Leading Outdoor Media Company",
    rating: 4.9,
    reviewCount: 3456,
    followers: 18700,
    itemsSold: 5680,
    joinedDate: "Feb 2017",
    responseTime: "Usually responds within 4 hours",
    location: "National Network",
    description: "Australia's premier outdoor media company with the largest network of premium advertising locations across all major cities and regional centers.",
    verified: true,
    brandColor: "#ec4899", // Pink/Magenta
    specialties: ["National Network", "Premium Locations", "Large Format"]
  },

  "ocean-outdoor": {
    id: "ocean-outdoor",
    name: "Ocean Outdoor Australia",
    logo: assetUrl("Ocean_logo_mono_black_cropped_1753786476146.png"),
    bannerImage: assetUrl("digitalBillboardBanner_1753792412449.jpg"),
    tagline: "Making Waves in Digital Out-of-Home",
    rating: 4.7,
    reviewCount: 2234,
    followers: 11200,
    itemsSold: 3401,
    joinedDate: "Sep 2018",
    responseTime: "Usually responds within 10 hours",
    location: "Sydney, Melbourne & Adelaide",
    description: "International outdoor advertising leader bringing world-class digital out-of-home solutions to Australia's major metropolitan markets.",
    verified: true,
    brandColor: "#000000", // Black
    specialties: ["Digital Innovation", "International Standards", "Metropolitan Focus"]
  },

  "eletromidia": {
    id: "eletromidia",
    name: "Eletromidia Networks",
    logo: assetUrl("eletromedia_1753786476146.webp"),
    bannerImage: assetUrl("piccadillyBanner_1753792412448.jpg"),
    tagline: "Powering Dynamic Digital Advertising",
    rating: 4.5,
    reviewCount: 1321,
    followers: 6800,
    itemsSold: 1789,
    joinedDate: "Apr 2022",
    responseTime: "Usually responds within 15 hours",
    location: "Perth & Adelaide",
    description: "Dynamic digital advertising specialists focusing on programmatic solutions and real-time campaign optimization across western and southern Australia.",
    verified: true,
    brandColor: "#f97316", // Orange
    specialties: ["Programmatic Advertising", "Real-time Optimization", "Digital Innovation"]
  },

  "stroer-media": {
    id: "stroer-media",
    name: "Ströer Media Deutschland",
    logo: assetUrl("Ströer Media Deutschland GmbH_2_1753786476148.png"),
    bannerImage: assetUrl("vegasBillboardBanner_1753792412449.jpg"),
    tagline: "Europe's Leading Digital Out-of-Home Network",
    rating: 4.6,
    reviewCount: 2876,
    followers: 14300,
    itemsSold: 4521,
    joinedDate: "Jan 2016",
    responseTime: "Usually responds within 8 hours",
    location: "International Network - Europe & USA",
    description: "Europe's largest digital out-of-home media company with premium advertising locations across major cities. Specializing in high-impact digital displays and programmatic advertising solutions.",
    verified: true,
    brandColor: "#0066cc", // Blue
    specialties: ["Digital Displays", "Programmatic DOOH", "International Network"]
  }
};

// Helper function to get media owner by ID
export const getMediaOwner = (id: string): MediaOwner | null => {
  return mediaOwners[id] || null;
};

// Get all media owners as array
export const getAllMediaOwners = (): MediaOwner[] => {
  return Object.values(mediaOwners);
};